import {post,get,deletes,put} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//新增算法
export const addNewAlgorithm = p => post(proxyHeader+'service/dataprocess-service/algorithm/uploadAlgorithm',p);

//删除算法
export const deleteAlgorithms = p => deletes(proxyHeader+'service/dataprocess-service/algorithm/deletes',p);

//删除算法
export const getMyAlgorithmList = p => get(proxyHeader+'service/dataprocess-service/algorithm/userList',p);

//算法详情
export const getAlgorithmDetail = p => get(proxyHeader+'service/dataprocess-service/algorithm/detail',p);

//算法编辑
export const updateAlgorithm = p => put(proxyHeader+'service/dataprocess-service/algorithm/updateAlgorithm',p);

//算法提交审核
export const submitAlgorithmApprovals = p => post(proxyHeader+'service/dataprocess-service/algoAlgorithmApprovals',p);

//算法审核列表
export const algoAlgorithmApprovals = p => get(proxyHeader+'service/dataprocess-service/algoAlgorithmApprovals',p);

//审核算法
export const approvalAlgorithm = p => post(proxyHeader+'service/dataprocess-service/algoAlgorithmApprovals/approval',p);

//算法分类
export const getAlgorithmType = p => get(proxyHeader+'service/dataprocess-service/algorithm/getAlgorithmType',p);


//门户算法列表
export const getAlgorithmListFromId = p => get(proxyHeader+'service/dataprocess-service/algorithm/algoList',p);

//门户算法列表
export const conutByAlgoId = p => get(proxyHeader+'service/product-service/product-data/conutByAlgoId',p);

//申请运行
export const applyCreateData = p => post(proxyHeader+'service/product-service/product-data-file/applyCreateData',p);

//获取输出路径
export const mkDirAndFtp = p => post(proxyHeader+'service/product-service/productftp/mkDirAndFtp',p);
